import './homepage.css';
import * as React from 'react';
import aerialphoto from './assets/aerial.jpg';
import PurpleairWebpageIncidentSummary from './purpleairWebpageIncidentSummary';
import { useNavigate} from 'react-router-dom';



const Homepage = ({ onNewPageForMenu }) => {

const handleImageClick =() =>{
  window.open('https://www.google.com/maps/@27.3501553,-82.541822,389m/data=!3m1!1e3?entry=ttu&g_ep=EgoyMDI1MDUyMS4wIKXMDSoASAFQAw%3D');
}

  const navigate = useNavigate();

const goToLearnMore = () =>{
  onNewPageForMenu('Learn More');
  navigate("/learnmore");
}

  return (
    <>
      <div className="container">
        <div className="row" >
          <div className="inner-box">
            <PurpleairWebpageIncidentSummary updateMenu={onNewPageForMenu} />
          </div>
        </div>
        <div className="row-bottom">
          <div className="inner-box">
            <div style={{ width: '100%', display: 'flex', height: '40vh' }}>
              <div className="column-left">
                  <img src={aerialphoto} alt="aerial of US Recycling" style={{cursor:'pointer',width:'40vw',maxWidth:'300px' }} onClick={handleImageClick} />
              </div>
              <div className="column-right">
                <p >Since 2021, US Recycling has been performing operations, such as cement crushing, resulting in an environmental hazard.</p>
                <p >This site is part of the <a href='https://sarasotaccna.org' target='_undefined'>Sarasota Coalition of City Neighborhood Associations</a> effort to improve air quality in the city of Sarasota.</p>
                <p>The purpose of the CCNA initiative is to stop the ongoing harmful operations and encourage an alternative use of the property.</p>
                <button onClick={goToLearnMore}
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    color: 'blue',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    font: 'inherit',
                  }} >Learn more</button> about the history and health risks.
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default Homepage;